import ProductLayout from '@/components/Products/ProductLayout';
import ProductList from '@/components/Products/ProductList';

const Products = () => {
  return (
    <ProductLayout>
      <ProductList />
    </ProductLayout>
  );
};

export default Products;
